import {
  observable,
  action
} from 'mobx'
import {store} from '../store.index';
export default class common {
  @observable isShowOpenMember = false;
  @observable axiosPromiseList = [];
  @observable isShowMeeting = false
  @observable isShowLoginLoseDialog = false
  @observable isLoginLoseDialog = false
  @observable protectAuthInter = null
  @observable protectAuthAddDom = false
  @observable docModifiedNoSave = false
  
  @action setIsShowMeeting(isShowMeeting) {
    this.isShowMeeting = isShowMeeting
  }
  @action getIsShowOpenMember(isShowOpenMember){
    this.isShowOpenMember = isShowOpenMember
  }
  @action setDocModifiedNoSave(docModifiedNoSave) {
    this.docModifiedNoSave = docModifiedNoSave
  }
  @action axiosPromiseCancel(){
    this.axiosPromiseList.forEach(e => {
      e && e('终止请求获取同步消息接口');
    });
    this.axiosPromiseList = [];
  }

  // h5交互修改添加 20211227
  @observable isShowNoPdfDialog = false
  @action setIsShowNoPdfDialog(isShowNoPdfDialog) {
    this.isShowNoPdfDialog = isShowNoPdfDialog
  }
  // 保护功能权限控制
  @action protectAuth() {
    this.protectAuthInter = setInterval(() => {
      let dom1 = document.querySelectorAll('[name="protect-tab-hidden-data"]')
      let dom4 = document.querySelectorAll('[name="password-protect-btn"]');
      let dom5 = document.querySelectorAll('[name="remove-protect-btn"]');
      let dom6 = document.querySelectorAll('[name="create-redaction-controllers"]');
      let dom2 = document.querySelectorAll('[name="redaction-apply"]');
      let dom3 = document.querySelectorAll('[name="redaction-search"]');
      if(store.userNewStore.userData && store.userNewStore.userData.identity === "vip") {
        if(this.protectAuthAddDom) {
          // 有蒙版，删除
          [dom1, dom4, dom5, dom6, dom2, dom3].map(item => {
            let childs = item[0].getElementsByClassName("addMaskDom");
            item[0].removeChild(childs[0]);
          })
          this.protectAuthAddDom = false
        }
        return
      } else {
        if(this.protectAuthAddDom) {
          return
        }
        // TODO FOXIT 这里添加一个修改 在保护功能上加几个蒙版
        if(dom1[0] && dom4[0] && dom5[0] && dom6[0] && dom2[0] && dom3[0] && !this.protectAuthAddDom) {
          this.protectAuthAddDom = true;
          [dom1, dom4, dom5, dom6, dom2, dom3].map(item => {
            let mask = document.createElement('div');
            mask.className="addMaskDom"
            item[0].style.position = "relative";
            item[0].appendChild(mask);
            mask.onclick=((e)=> {
              if(store.userNewStore.userData.identity !== "vip") {
                store.common.getIsShowOpenMember(true);
                e.stopPropagation()
                return
              }
            })
          })
        }
      }
    }, 1000)
  }
}
